if (!model.editable)
  .pure-g.product-row(data-id=model.id, data-hook="subview")
else
  .pure-g.product-row-edit
    .pure-u-1
      .cell(data-hook="subview")
